import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Series.css';
import { Grid } from '@mui/material';
//import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { DragNDropListOrderCollections } from './DragNDropListOrderCollections';
import { CRUD_STATES, PAGE_COLLECTION_VIDEO_LIST } from 'constants/app';
import { Tooltip } from 'components/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { VideoOrSerieModal } from 'components/TableWithCheck/VideoOrSerieModal';
import { useTableSelectedList } from 'hooks/useTableSelectedList';
import { targetAudiencesLabel } from 'constants/fields';
import { Chip } from '@mui/material';

function SeriesStep1(props) {
  const { setValue, getValues, viewFields, setIsEdit } = props;

  const location = useLocation();

  const pageCollectionVideoList = useTableSelectedList(
    PAGE_COLLECTION_VIDEO_LIST
  );

  const targetAudiences = getValues('targetAudiences');

  useEffect(() => {
    if (
      location?.state?.action === CRUD_STATES.EDIT ||
      location?.state?.action === CRUD_STATES.VIEW
    ) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="step-container" id="collection-step-one">
      <Grid justifyContent="flex-end" alignItems="flex-end" container>
        {targetAudiences?.length > 0 && (
          <Chip
            label={` Público-alvo: 
                ${
                  targetAudiences?.length === 5
                    ? 'Todos'
                    : targetAudiences
                        ?.map(i => targetAudiencesLabel[i])
                        .join(', ')
                }`}
            color="info"
            size="small"
          />
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <div className="video_label-title">
            Vídeos da série{' '}
            <span style={{ fontSize: 12 }}>({getValues('title')})</span>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end">
          <div style={{ display: 'flex', marginLeft: '68%' }}>
            <span
              style={{
                fontWeight: 500,
                fontSize: 12,
                color: 'rgb(194, 194, 195)',
              }}>
              Sugerir tempo para exibição do vídeo(opcional)
            </span>

            <Tooltip.Info
              title="Info"
              description=" Especifique o tempo antes do final do vídeo para mostrar a próxima sugestão da série, em caso da não especificação o tempo padrão para exibição é 60s."
              show>
              <InfoIcon sx={{ color: '#7CB9E8', fontSize: 20 }} />
            </Tooltip.Info>
          </div>
        </Grid>
        {!!pageCollectionVideoList?.selectedItems?.length && (
          <DragNDropListOrderCollections
            id="colection-drag-drop-video"
            viewFields={viewFields}
            setValue={setValue}
            getValues={getValues}
            videoToCollection={pageCollectionVideoList.selectedItems}
            setVideoToCollection={values => {
              if (typeof values === 'function') {
                return pageCollectionVideoList.setSelectedItems(
                  values(pageCollectionVideoList.selectedItems)
                );
              }

              return pageCollectionVideoList.setSelectedItems(values);
            }}
          />
        )}
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          marginTop: '16px',
        }}>
        <Grid item xs={12}>
          <div className="step-button-group">
            <VideoOrSerieModal
              id="select-video-collection"
              disabled={viewFields}
              itemName={
                getValues('title')
                  ? `Série ${getValues('title')}`
                  : 'Nova série'
              }
              openButtonLabel="Associar Vídeo a série"
              backButtonLabel="Voltar"
              listId={PAGE_COLLECTION_VIDEO_LIST}
              count={{
                selectedLength: pageCollectionVideoList.selectedItems?.length,
                template: '$count selecionado(s)',
              }}
              disableGutters
              fixedStep="video"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default SeriesStep1;


